import http from "./http";

export default {
    checkLogoutStatus(params){
        return http.get("common-user/user/account/checkLogoutStatus", params);
    },
    verLogoutCode(params){
        return http.get("common-user/user/account/verLogoutCode", {params});
    },
    plogout(params){
        return http.get("common-user/user/account/logout", {params});
    },
}
